import {PointerSensor, useSensor, useSensors} from '@dnd-kit/core';

export const useDefaultDndSensors = () => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    })
  );

  return sensors;
};
